import {gql} from '@apollo/client'

export const GET_PATIENT_LIST_PAGINATION = gql`
  query getBusinessPatientPaginationList(
    $page: Int!
    $limit: Int!
    $field: String
    $value: String
    $sortBy: String
    $sortOrder: Int
  ) {
    getBusinessPatientPaginationList(
      listFilter: {page: $page, limit: $limit, sortBy: $sortBy, sortOrder: $sortOrder}
      queryFilter: {field: $field, value: $value}
    ) {
      data {
        id
        mobileNumber
        firstName
        lastName
        dob
        registrationDate
        name
        userRoleId
        gender
        userId
        profilePhoto
        age
      }
      total
      pageSize
      page
      totalPages
    }
  }
`

export const GET_PATIENT_LIST_PAGINATION_WITH_FAMILY_MEMBER_SEARCH = gql`
  query getPatientsAndFamilyMembersPaginationList(
    $page: Int!
    $limit: Int!
    $field: String
    $value: String
    $sortBy: String
    $sortOrder: Int
  ) {
    getPatientsAndFamilyMembersPaginationList(
      listFilter: {page: $page, limit: $limit, sortBy: $sortBy, sortOrder: $sortOrder}
      queryFilter: {field: $field, value: $value}
    ) {
      data {
        id
        mobileNumber
        firstName
        lastName
        dob
        registrationDate
        name
        userRoleId
        gender
        userId
        profilePhoto
        age
        isFamilyMemberRegistered
        type
      }
      total
      pageSize
      page
      totalPages
    }
  }
`

export const ADD_PATIENT = gql`
  mutation importPatients(
    $firstName: String!
    $lastName: String!
    $countryCode: Int!
    $mobileNumber: String!
    $gender: GENDER
    $address: String
    $zipCode: String
    $city: String
    $district: String
    $state: String
    $country: String
    $dob: Date
  ) {
    importPatients(
      patientInput: {
        firstName: $firstName
        lastName: $lastName
        countryCode: $countryCode
        mobileNumber: $mobileNumber
        gender: $gender
        zipCode: $zipCode
        city: $city
        district: $district
        state: $state
        country: $country
        address: $address
        dob: $dob
      }
    ) {
      fileReport
      message
    }
  }
`

export const ADD_PATIENT_BY_STAFF = gql`
  mutation addPatientsInClinic(
    $firstName: String!
    $lastName: String!
    $countryCode: Int!
    $mobileNumber: String!
    $gender: GENDER
    $address: String
    $zipCode: String
    $city: String
    $district: String
    $state: String
    $country: String
    $dob: Date
    $doctorId: ID!
    $doctorRoleId: ID
  ) {
    addPatientsInClinic(
      patientInput: {
        firstName: $firstName
        lastName: $lastName
        countryCode: $countryCode
        mobileNumber: $mobileNumber
        gender: $gender
        zipCode: $zipCode
        city: $city
        district: $district
        state: $state
        country: $country
        address: $address
        dob: $dob
      }
      doctorId: $doctorId
      doctorRoleId: $doctorRoleId
    )
  }
`

export const ADD_PATIENT_USING_EXCEL = gql`
  mutation importPatients($doctorId: String, $patientInputs: [patientInput!]!) {
    importPatients(doctorId: $doctorId, patientInput: $patientInputs)
  }
`

export const IMPORT_PATIENT = gql`
  mutation importPatients(
    $fileDataString: String!
    $doctorId: String
    $fileMimeType: String
    $fileName: String
  ) {
    importPatients(
      fileDataString: $fileDataString
      doctorId: $doctorId
      fileMimeType: $fileMimeType
      fileName: $fileName
    ) {
      fileReport
      message
    }
  }
`

export const DELETE_PATIENT = gql`
  mutation deleteBusinessPatient($userRoleId: ID!) {
    deleteBusinessPatient(userRoleId: $userRoleId)
  }
`

export const GET_PATIENT_BY_ID = gql`
  query getBusinessUserProfile($id: ID!) {
    getBusinessUserProfile(userRoleId: $id) {
      userProfile {
        id
        userId
        userRoleId
        firstName
        lastName
        gender
        dob
        bloodGroup
        email
        profilePhoto
      }
      userAddress {
        zipCode
        street
        city
        district
        state
        country
      }
      isUserRegistered
      mobileNumber
      countryCode
      registrationDate
      age
    }
  }
`

export const EDIT_PATIENT = gql`
  mutation editBusinessPatient(
    $userRoleId: ID!
    $firstName: String!
    $lastName: String!
    $countryCode: Int!
    $mobileNumber: String
    $gender: GENDER
    $zipCode: String
    $city: String
    $district: String
    $state: String
    $country: String
    $address: String
    $dob: Date
    $bloodGroup: String
  ) {
    editBusinessPatient(
      userRoleId: $userRoleId
      patientInput: {
        firstName: $firstName
        lastName: $lastName
        countryCode: $countryCode
        mobileNumber: $mobileNumber
        gender: $gender
        dob: $dob
        bloodGroup: $bloodGroup
        zipCode: $zipCode
        city: $city
        district: $district
        state: $state
        country: $country
        address: $address
      }
    )
  }
`

export const EDIT_FAMILY_MEMBER_BY_ID = gql`
  mutation updateFamilyMemberDetailByDoctor(
    $userId: ID!
    $firstName: String!
    $lastName: String!
    $email: String
    $dob: Date
    $gender: GENDER
    $relation: String!
    $bloodGroup: String
    $address: String
    $zip: String
    $district: String
    $city: String
    $state: String
    $country: String
  ) {
    updateFamilyMemberDetailByDoctor(
      userId: $userId
      familyMemberInput: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        dob: $dob
        gender: $gender
        relation: $relation
        bloodGroup: $bloodGroup
        address: $address
        zip: $zip
        district: $district
        city: $city
        state: $state
        country: $country
      }
    )
  }
`

export const EDIT_INVENTOR_PRODCT = gql`
  mutation editInventoryProduct($id: ID!, $productDetails: purchaseOrderDetails!) {
    editInventoryProduct(id: $id, productDetails: $productDetails)
  }
`

export const GET_DOCTOR_LIST = gql`
  query getBusinessStaffList($role: String!) {
    getBusinessStaffList(role: $role) {
      userId
      userRoleId
      firstName
      lastName
      role
      profilePhoto
      isRegistered
      updatedDate
    }
  }
`

export const GET_PATIENT_APPOINTMENT_LIST = gql`
  query getPatientAppointmentListV2(
    $patientId: ID!
    $doctorId: ID
    $date: Date!
    $timeZone: String!
  ) {
    getPatientAppointmentListV2(
      patientId: $patientId
      doctorId: $doctorId
      date: $date
      timeZone: $timeZone
    ) {
      id
      firstName
      lastName
      isPrescriptionSent
      appointmentType
      appointmentMode
      appointmentStartTime
    }
  }
`

export const GET_FAMILY_MEMBERLIST = gql`
  query getFamilyMemberByUserID($userId: ID!) {
    getFamilyMemberByUserID(userId: $userId) {
      userId
      firstName
      lastName
      userRoleId
      relation
    }
  }
`

export const ADD_FAMILY_MEMBER = gql`
  mutation addfamilyMember(
    $userId: ID
    $relation: String!
    $firstName: String!
    $lastName: String!
    $gender: GENDER
    $address: String
    $zipCode: String
    $city: String
    $district: String
    $state: String
    $country: String
    $dob: Date
    $bloodGroup: String
    $isVisibleToDoctor: Boolean
  ) {
    addfamilyMember(
      userId: $userId
      familyMemberInput: {
        relation: $relation
        firstName: $firstName
        lastName: $lastName
        gender: $gender
        bloodGroup: $bloodGroup
        zip: $zipCode
        city: $city
        district: $district
        state: $state
        country: $country
        address: $address
        dob: $dob
        isVisibleToDoctor: $isVisibleToDoctor
      }
    ) {
      id
    }
  }
`
export const GET_BUSINESS_DOCTOR_LIST = gql`
  query getBusinessDoctorList($businessProfileId: ID!, $doctorName: String) {
    getBusinessDoctorList(businessProfileId: $businessProfileId, doctorName: $doctorName) {
      mobileNumber
      doctorRoleId
      userProfile {
        id
        userId
        userRoleId
        firstName
        lastName
      }
    }
  }
`

export const GET_BUSINESS_DOCTOR_DATA = gql`
  query getBusinessDoctorData($businessProfileId: ID!, $doctorName: String) {
    getBusinessDoctorData(businessProfileId: $businessProfileId, doctorName: $doctorName) {
      doctorRoleId
      doctorName
    }
  }
`
export const GET_BUSINESS_DOCTOR_LIST_FOR_COMPLAIN = gql`
  query getBusinessDoctorData($businessProfileId: ID!, $limit: Int) {
    getBusinessDoctorData(businessProfileId: $businessProfileId, limit: $limit) {
      doctorId
      doctorRoleId
      doctorName
      businessId
      speciality
      specialityId
    }
  }
`

export const GET_COMPLAIN_LIST = gql`
  query getBusinessConsumerComplainList(
    $specialtyIds: [ID!]
    $doctorId: ID!
    $searchText: String
    $listFilter: listFilterInput!
  ) {
    getBusinessConsumerComplainList(
      specialtyIds: $specialtyIds
      doctorId: $doctorId
      searchText: $searchText
      listFilter: $listFilter
    ) {
      data {
        id
        code
        translations {
          ENGLISH
          TAMIL
          HINDI
          KANNADA
          TELUGU
        }
        isActive
        isVisibleToConsumer
        isMaster
      }
      total
      pageSize
      page
      totalPages
    }
  }
`

export const ADD_CONSUMER_COMPLAIN = gql`
  mutation createBusinessConsumerComplain(
    $businessConsumerComplainInput: businessConsumerComplainInput!
  ) {
    createBusinessConsumerComplain(conCompInput: $businessConsumerComplainInput)
  }
`

export const EDIT_CONSUMER_COMPLAIN = gql`
  mutation updateBusinessConsumerComplain(
    $id: ID!
    $businessConsumerComplainInput: businessConsumerComplainInput!
  ) {
    updateBusinessConsumerComplain(id: $id, conCompInput: $businessConsumerComplainInput)
  }
`

export const UPDATE_CONSUMER_COMPLAIN_VISIBILITY = gql`
  mutation updateBusinessConsumerComplainVisiblity(
    $id: ID!
    $doctorId: ID!
    $isVisibleToConsumer: Boolean!
  ) {
    updateBusinessConsumerComplainVisiblity(
      id: $id
      doctorId: $doctorId
      isVisibleToConsumer: $isVisibleToConsumer
    )
  }
`

export const GET_DOCTOR_PATIENT_LIST_PAGINATION = gql`
  query getClinicPatientList(
    $doctorId: ID
    $page: Int!
    $limit: Int!
    $sortBy: String
    $sortOrder: Int
  ) {
    getClinicPatientList(
      doctorId: $doctorId
      listFilter: {page: $page, limit: $limit, sortBy: $sortBy, sortOrder: $sortOrder}
    ) {
      data {
        id
        userId
        userRoleId
        mobileNumber
        name
        registrationDate
        updatedDate
        profilePhoto
        gender
        userAddress {
          id
        }
        firstName
        lastName
        dob
      }
      page
      pageSize
      total
      totalPages
    }
  }
`
